export default __webpack_public_path__ + "staticlp1/media/banner-home-1366x637.71c7e8c7.png";